import React from 'react'

import './Backdrop.css'

export function Backdrop( props ) {
  return (
    <div className="backdrop" />
  );
}
